import { useEffect, useState } from "react";
import { ChevronDown } from 'lucide-react';

const options = {
    Genre: [
        'Acoustic', 'Afrobeat', 'Ambient', 'Blues', 'Country',
        'Drum \'n\' Bass', 'Electronic', 'Experimental', 'Folk', 'Funk',
        'Hip-Hop/Grime', 'House', 'Indie Pop', 'Indie Rock', 'Jazz',
        'Latin', 'Lo-Fi', 'Metal', 'Orchestral/Classical', 'Pop',
        'Punk', 'R\'n\'B', 'Reggae', 'Rock', 'Soul', 'Techno', 'Trance', 'Trap'
    ],
    Style: [
        'Aggressive', 'Airy/Expansive', 'Bright', 'Gritty/Crunchy',
        'Mellow/Smooth', 'Sharp/Bassy', 'Thumping/Boomy', 'Warm', 'Neutral'
    ],
};

const valueMap = {
    'Acoustic': 'ACOUSTIC', 'Afrobeat': 'AFROBEAT', 'Ambient': 'AMBIENT',
    'Blues': 'BLUES', 'Country': 'COUNTRY', 'Drum \'n\' Bass': 'DRUM_N_BASS',
    'Electronic': 'ELECTRONIC', 'Experimental': 'EXPERIMENTAL', 'Folk': 'FOLK',
    'Funk': 'FUNK', 'Hip-Hop/Grime': 'HIP_HOP_GRIME', 'House': 'HOUSE',
    'Indie Pop': 'INDIE_POP', 'Indie Rock': 'INDIE_ROCK', 'Jazz': 'JAZZ',
    'Latin': 'LATIN', 'Lo-Fi': 'LO_FI', 'Metal': 'METAL',
    'Orchestral/Classical': 'ORCHESTRAL', 'Pop': 'POP', 'Punk': 'PUNK',
    'R\'n\'B': 'RNB', 'Reggae': 'REGGAE', 'Rock': 'ROCK', 'Soul': 'SOUL',
    'Techno': 'TECHNO', 'Trance': 'TRANCE', 'Trap': 'TRAP',
    'Aggressive': 'AGGRESSIVE', 'Airy/Expansive': 'AIRY_EXPANSIVE',
    'Bright': 'BRIGHT', 'Gritty/Crunchy': 'GRITTY_CRUNCHY',
    'Mellow/Smooth': 'MELLOW_SMOOTH', 'Sharp/Bassy': 'SHARP_BASSY',
    'Thumping/Boomy': 'THUMPING_BOOMY', 'Warm': 'WARM', 'Neutral': 'NEUTRAL',
};

const reverseValueMap = Object.fromEntries(
    Object.entries(valueMap).map(([label, value]) => [value, label])
);

export function GenreAndStyleDropdown({ backgroundColor, getSelectedOption, defaultValue }) {
    const initialLabel = defaultValue ? (reverseValueMap[defaultValue?.toUpperCase()] ?? '') : '';

    const [selectedOption, setSelectedOption] = useState(initialLabel);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    useEffect(() => {
        if (defaultValue) {
            const label = reverseValueMap[defaultValue] ?? '';
            if (label) setSelectedOption(label);
        }
    }, [defaultValue]);

    return (
        <div className="max-w-2xl mx-auto relative">
            <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                aria-expanded={isDropdownOpen}
                className={`w-full flex items-center justify-between p-4 rounded-2xl border-2 border-theme_clr2 ${backgroundColor} text-white text-lg`}
            >
                <span className="truncate mr-3">{selectedOption || 'Select Genre or Style'}</span>
                <ChevronDown size={18} className={`transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
            </button>

            {isDropdownOpen && (
                <div className={`absolute left-0 right-0 mt-2 w-full rounded-b-2xl shadow-2xl z-50 ${backgroundColor}`}>
                    <div className="max-h-72 overflow-y-auto">
                        {Object.entries(options).map(([category, items]) => (
                            <div key={category}>
                                <div className="bg-white py-2 sticky top-0">
                                    <p className="px-4 py-2 text-red-600 font-semibold">{category}</p>
                                </div>
                                {items.map((item) => (
                                    <button
                                        key={item}
                                        onClick={() => {
                                            setSelectedOption(item);
                                            getSelectedOption(valueMap[item]);
                                            setIsDropdownOpen(false);
                                        }}
                                        className={`w-full text-left px-4 py-3 transition-colors ${
                                            selectedOption === item
                                                ? 'bg-orange-700 text-white font-medium'
                                                : 'text-white hover:bg-orange-600'
                                        }`}
                                    >
                                        {item}
                                    </button>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}